var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoFds = function SvgLogoFds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 39,
    viewBox: "0 0 365 128"
  }, props), /*#__PURE__*/React.createElement("text", {
    style: {
      fontFamily: "Verdana-Bold,Verdana",
      fontSize: 169,
      fontWeight: 700,
      fill: "#fff"
    },
    transform: "translate(-15.4 125.4)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FDS"))));
};
export default SvgLogoFds;